import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'nrwl-endpoint-selection-panel',
  templateUrl: './endpoint-selection-panel.component.html',
  styleUrls: ['./endpoint-selection-panel.component.scss']
})
export class EndpointSelectionPanelComponent implements OnInit {
  // eslint-disable-next-line
  @Input() endpointValue: BehaviorSubject<any>;
  @Input() editMode: boolean;
  @Input() disabled: boolean;
  @Input() disabledMessage: string;
  // eslint-disable-next-line
  @Input() endpointConfiguration: any;
  @Input() loopbackType = '';
  // eslint-disable-next-line
  @Output() openEndpoint: EventEmitter<any> = new EventEmitter<any>();
  _unSubscribe: Subscription;
  selectedEndpoints = [];
  endpointInfo = { title: '', label: '', subLabel: '', subLabel1: '' };
  warningMessage: string;
  selectionMessage: string;
  ngOnInit(): void {
    this.selectionMessage = this.endpointConfiguration?.selectionName
      ? ' ' + this.endpointConfiguration.selectionName + ' have been selected'
      : ' items have been selected';
    if (this.endpointValue) {
      this._unSubscribe = this.endpointValue.subscribe(data => {
        if (data && data.length) {
          this.selectedEndpoints = data;
          this.setEndpoints();
        } else {
          this.setEmptyEndpoints();
        }
      });
    }
  }
  setEndpoints(): void {
    this.warningMessage = null;
    const selectedInfo = this.selectedEndpoints[0];
    if (!selectedInfo.id || !selectedInfo.itemType) {
      this.endpointInfo.title = selectedInfo.title;
      this.endpointInfo.label = selectedInfo.label;
      this.endpointInfo.subLabel = selectedInfo.subLabel;
    } else {
      this.endpointInfo.title =
        selectedInfo.itemType === 'device' ? selectedInfo.name.label : selectedInfo.site.label;
      this.endpointInfo.label = selectedInfo?.label;
      this.endpointInfo.subLabel = selectedInfo.subLabel;
      this.endpointInfo.subLabel1 = selectedInfo?.subLabel1;
      const showWarning = this.selectedEndpoints.some(item => item?.isWarningMessage);
      if (showWarning && this.selectedEndpoints.length) {
        this.warningMessage =
          this.selectedEndpoints.length === 1
            ? 'This test will be queued due to resource availability'
            : 'One or more tests will be queued due to resource availability';
      }
      const showAvailableWarning = this.selectedEndpoints.some(item => item.notAvailed);
      if (showAvailableWarning && this.selectedEndpoints.length) {
        this.warningMessage =
          this.selectedEndpoints.length === 1
            ? 'Endpoint does not match with inventory'
            : 'Some endpoints are does not match with inventory';
      }
    }
  }
  setEmptyEndpoints(): void {
    this.endpointInfo = { title: '', label: '', subLabel: '', subLabel1: '' };
    this.selectedEndpoints = [];
  }

  viewEdpoints(): void {
    this.openEndpoint.emit();
  }
}
